<template>
<!-- 县域专区 -->
  <div id="countySearchList">
    <div class="top-header">
      <div class="header-bg">
        <div class="search">
          <div style="position: relative;width: calc(100% - 44px);display: inline-block;vertical-align: middle">
            <i class="icon iconfont iconsousuo search-icon"></i>
            <input class="allInput searchBar" type="text" v-model="searchData.keywords" style="padding: 0 30px 0 33px!important;">
            <i class="icon iconfont iconguanbi empty-icon" @touchstart="clearInput"></i>
          </div>
          <span class="f_w m_l_10 font14" style="color: white" @click="toUrl()">取消</span>
        </div>
        <div :class="{'top-menu': true, 'top-menu-active': showHeadMenu}" @click="toggleHeadMenu" style="display: none;">
          <i :class="{'icon':true, 'iconfont':true, 'iconhanbaocaidan': true, 'menu-icon':true, 'menu-icon-active': showHeadMenu}" style="font-size: 20px!important;"></i>
          <!-- 隐藏菜单 -->
          <div v-show="showHeadMenu" class="top-menu-list">
            <div style="">
              <i class="icon iconfont iconshuqian" style="color: #E71222;"></i>
              <span style="margin-left: 5px;font-size: 14px;">我的收藏</span>
            </div>
            <div style="margin-top:15px;">
              <i class="icon iconfont icongerenzhongxin1" style="color: #E71222;"></i>
              <span style="margin-left: 5px;font-size: 14px;">个人中心</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="artical-container">
      <!-- <div class="artical-header">
        <div class="interest">
          <i class="icon iconfont iconaixin" style="color: #E71222;font-size: 20px!important;font-weight: bold;line-height: 30px;"></i>
          <span class="interest-txt">兴趣</span>
        </div>
      </div> -->
      <div class="artical-list">
        <template v-if="totalArticleList.length > 0">
          <div class="artical-item" v-for="(item, index) in totalArticleList" :key="index">
            <div class="artical-item-pic" @click="goJumpLink($event,item)">
              <img class="img" :src="baseUrl + '/api/Article/file/' + item.fileID" alt="">
            </div>
            <div class="artical-item-info">
              <!-- 渐变线条 -->
              <div class="colorful-boder"></div>
              <div class="right">
                <div class="item-info-title">
                  {{item.title}}
                </div>
                <div class="item-info-read d_in v_m">
                  <i class="icon iconfont iconcalendar" style="color: rgb(137,137,137);" v-if="item.firstSubmitTime"></i>
                  <span class="num">{{item.firstSubmitTime ? $commonJs.returnDate(item.firstSubmitTime, 'YYMMDD1') : ''}}</span>
                </div>
                <div class="item-info-read d_in v_m">
                  <i class="icon iconfont iconkaiyanjing" style="color: rgb(137,137,137);"></i>
                  <span class="num">{{item.viewCount}}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="notList" style="text-align:center;color:rgb(137,137,137);">没有更多了</div>
        </template>
        <div v-else style="text-align:center;margin-top: 50px;">
          {{noDataText}}
        </div>
      </div>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>
<script>
import agreeBookDialog from "./agreeBookDialog";
export default {
  name: 'countySearchList',
   components: {
    agreeBookDialog
  },
  data () {
    return {
      baseUrl: process.env.config.baseUrl,
      searchData: {
        keywords: ''
      },
      showPage: false,
      showHeadMenu: false,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      showGuide: false,
      userInfo: {},
      ABDialogShow:false,
      fieldsList: JSON.parse(this.$route.query.fieldsList) || [],
      indicationList: [],
      articleList: [],
      totalArticleList: [],
      noDataText: '',
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      totalPage: 0,
      skipcarouselCount: 0,
      notList: false,
      canSearch: true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler, true)
  },
  created () {
    // if (!this.takedacode) {
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
    //   window.location.href = url
    // } else {
    //   this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
    //     window.localStorage.setItem('TaToken', msg.token)
    //     window.localStorage.setItem('appId', msg.appId)
    //     window.localStorage.setItem('openId', msg.openId)
    //     this.openId = msg.openId
    //     let isEmployee = window.localStorage.getItem('isEmployee')
    //     let allAxiox = ''
    //     if (isEmployee) {
    //       allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee/' + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl))
    //     } else {
    //       let data = {
    //         openid: this.openId,
    //         returnurl: encodeURIComponent(this.returnurl)
    //       }
    //       allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
    //     }
    //     allAxiox.then(msg => {
    //       console.log(msg, 'getDoctor')
    //       if (msg.isSuccess) {
    //         if (msg.data.status === 2) {
    //           window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //         } else if (msg.data.status === 3) {
    //           window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //         } else {
    //           if (msg.data.isFollowed) {
    //             this.showPage = true
    //             // 获取用户信息
    //             this.getUserInfo()
    //           } else {
    //             // this.$commonJs.closeWindow()
    //             this.showGuide = true
    //           }
    //         }
    //       }
    //     })
    //   })
    // }
    // if (!this.$route.query.openid) {
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/articalCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
    //   window.location.href = url
    // } else {
    //   this.openId = this.$route.query.openid
    //   let isEmployee = window.localStorage.getItem('isEmployee')
    //   let requestUrl = ''
    //   if (isEmployee) {
    //     requestUrl = '/api/wechat/getEmployee/'
    //   } else {
    //     requestUrl = '/api/wechat/getDoctor/'
    //   }
    //   this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
    //     console.log(msg, 'getDoctor')
    //     if (msg.isSuccess) {
    //       if (msg.data.status === 2) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       }
    //       else if (msg.data.status === 3) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else {
    //         if (msg.data.isFollowed) {
    //           this.showPage = true
    //           // 获取用户信息
    //           this.getUserInfo()
    //         } else {
    //           // this.$commonJs.closeWindow()
    //           this.showGuide = true
    //         }
    //       }
    //     }
    //   })
    // }

  setTimeout(() => {
    this.getSignDetail();
    }, 1000);

  },
  mounted () {
    document.title = '血液制品专区'
    //监听如果页面发生滚动时
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scrollHandler, true)
    })
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {

            //name: "agreeBook",
            this.ABDialogShow = true;

        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    toUrl () {
      this.searchData.keywords = ''
      let queries = this.$route.query
      this.$router.push({
        path: '/countyCollections',
        query: {
          ...queries
        }
      })
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    toggleHeadMenu () {
      this.showHeadMenu = !this.showHeadMenu
    },
    // 获取用户信息
    getUserInfo () {
      let isEmployee = window.localStorage.getItem('isEmployee')
      let requestUrl2 = ''
      if (isEmployee) {
        requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
      } else {
        let data = {
          openId: this.openId
        }
        requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
      }
      requestUrl2.then(msg => {
        console.log(msg, 'msg')
        if (msg.isSuccess) {
          this.userInfo = msg.data
          // 获取推荐文章
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        }
      })
    },
    // 获取推荐文章
    getArticals (department, fields) {
      console.log(this.skipcarouselCount, 'skipcarouselCount')
      this.notList = false
      let fieldNames = fields.map(val => val.name)
      let keywords = this.searchData.keywords
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&fieldNames=' + item
      })
      console.log(str, 'str')
      let url = ''
      if (department || (fieldNames && fieldNames.length > 0)) {
        // url = `/api/minisite/QueryMinisiteArticles?department=${department}&keywords=${keywords}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
        url = `/api/minisite/QueryMinisiteArticlesCountry?t=${new Date().getTime()}&keywords=${keywords}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
      } else {
        url = `/api/minisite/QueryMinisiteArticlesCountry?keywords=${keywords}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      }
      this.canSearch = false
      this.$axiox.getList(url).then(res => {
        console.log(res, 'getArticals')
        this.canSearch = true
        if (res.data && res.data.length > 0) {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = 0
          this.noDataText = '更多精彩内容，敬请期待！'
        }
      })
    },
    goJumpLink (e, slide) {
      e.stopPropagation()
      console.log(slide, 'slide')
      let queries = JSON.parse(JSON.stringify(this.$route.query))
      delete queries.skipcarouselCount
      delete queries.fieldsList
      queries.id = slide.articleId
      queries.source = 'WY'
      let url = this.$commonJs.returnQuery('//' + window.location.host + '/mobileContent', queries)
      window.location.href = url
      // this.$router.push({
      //   path: '/mobileContent',
      //   query: {
      //     id: slide.articleId,
      //     source: 'WY',
      //     ...queries
      //   }
      // })
    },
    clearInput () {
      this.searchData.keywords = ''
    },
    scrollHandler () {
      var scrollTop = document.documentElement.scrollTop; //滚动条的位置
      var windowHeitht = document.documentElement.clientHeight; //在页面上返回内容的可视高度
      var scrollHeight = document.documentElement.scrollHeight; //返回整个元素的高度（包括带滚动条的隐蔽的地方）
      //是否滚动到底部的判断
      if (scrollHeight - windowHeitht - scrollTop < 1) {
        console.log('滚到底了')
        // 页数加1
        this.pageIndex += 1
        if (this.pageIndex <= this.totalPage) {
          // 获取推荐文章
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        } else {
          this.notList = true
          return
        }
      }
    }
  },
  watch: {
    "searchData.keywords" (newData) {
      console.log(newData, 'newData')
      this.totalArticleList = []
      this.pageIndex = 1

      this.searchData.keywords = newData.trim()
      let fields = this.fieldsList.filter(val => val.checked)
      if (this.canSearch){
        this.getArticals(this.userInfo.department, fields)
      }
    }
  }
}
</script>
<style scoped>
  #articalCollections {
    width: 100%;
  }
  .top-header {
    width: 100%;
    height: 60px;
  }
  .header-bg {
    width: 100%;
    height: 90px;
    background-color: #FF4D4F;
    border-radius: 0px 0px 45px 45px;
    display: flex;
    flex-direction: row;
    padding: 15px 20px;
    box-sizing: border-box;
    justify-content: space-around;
  }
  .search {
    width: 100%;
    height: 35px;
    position: relative;
  }
  .searchBar {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border: none;
    border-radius: 30px;
    background-color: #E71222;
    box-sizing: border-box;
    color: #ffffff;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .search-icon {
    color: #ffffff;
    position: absolute;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .empty-icon {
    color: #ffffff;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .top-menu {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E71222;
    text-align: center;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
    position: relative;
  }
  .top-menu-active {
    background-color: #ffffff;
  }
  .top-menu-list {
    width: 100px;
    background-color: #FFFFFF;
    padding: 15px 5px;
    border-radius: 10px;
    position: absolute;
    right: 22px;
    top: 28px;
    z-index: 1;
  }
  .menu-icon {
    color: #ffffff;
    line-height: 35px;
  }
  .menu-icon-active {
    color: #E71222;
  }
  .carousel-container {
    width: 90%;
    height: 160px;
    margin: 0 auto;
    position: relative;
  }
  .carousel-list {
    width: 100%;
    height: 220px;
    margin: 0 auto;
    border-radius: 15px;
  }
  .artical-container {
    width: 100%;
    background-color: #ffffff;
    border-radius: 45px 45px 0px 0px;
    /* min-height: 502px; */
    /* padding-top: 90px; */
    min-height: calc(100vh - 90px);
    padding-bottom: 50px;
    padding-top: 30px;
  }
  .artical-header {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row-reverse;
    /* justify-content: space-between; */
    margin-bottom: 20px;
  }
  .recommend,
  .interest {
    height: 30px;
    box-sizing: border-box;
  }
  .interest {
    border-radius: 20px;
    border: 1px solid #E71222;
    padding: 0 15px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .recommend-txt,
  .interest-txt {
    color: rgb(16, 16, 16);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    line-height: 30px;
    margin-left: 5px;
  }
  .interest-txt {
    color: #E71222;
  }
  .artical-list {
    width: 90%;
    margin: 0 auto;
  }
  .artical-item {
    width: 100%;
    margin-bottom: 20px;
  }
  .artical-item-pic {
    overflow: hidden;
    border-radius: 15px;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .artical-item-pic .img {
    display: block;
    width: 100%;
  }
  .artical-item-info {
    display: flex;
    flex-direction: row;
    margin-top: 6px;
  }
  .colorful-boder {
    min-height: 40px;
    width: 10px;
    border-radius: 15px;
    background-image: linear-gradient(to bottom, #E71222, #FBAEA6);
  }
  .right {
    padding: 5px 7px;
  }
  .right .item-info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .right .item-info-read {

  }
  .right .item-info-read .num {
    /* color: rgb(192,192,192); */
    color: rgb(137,137,137);
    font-size: 12px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/countySearchList.vue